import { ADULT_GUEST, CHILD_GUEST, SENIOR_GUEST, TEEN_GUEST, TODDLER_GUEST } from '../styles/colors';


/**
 * Maps an age group (which you likely got from the guest's entitlements' name values) into a color.
 */
export const colorForAgeGroup = (ageGroup: string | undefined): string => {
  switch ((ageGroup || '').toLowerCase()) {
    case 'under5':
      return TODDLER_GUEST;

    case 'child':
      return CHILD_GUEST;

    case 'teen': // Ikon 2018-2019
    case 'youngadult': // Going forward
      return TEEN_GUEST;

    case 'adult':
      return ADULT_GUEST;

    case 'senior':
      return SENIOR_GUEST;

    default:
      return ADULT_GUEST;
  }
};
